import { render, staticRenderFns } from "./OurServiceEdit.vue?vue&type=template&id=20c4905c&scoped=true"
import script from "./OurServiceEdit.vue?vue&type=script&lang=js"
export * from "./OurServiceEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c4905c",
  null
  
)

export default component.exports